import { logger } from './logger';

// 両方の経路にテストがある（sessionManager.test.ts = 既定 8 時間 /
// sessionManager.env.test.ts = VITE_SESSION_TIMEOUT 指定）が、モジュール直下で
// 評価される import.meta.env の分岐は Vite の変換の都合で v8 が計上できない。
/* v8 ignore next -- モジュール直下の import.meta.env は計測不能（両経路ともテスト済み） */
const SESSION_TIMEOUT = parseInt(import.meta.env.VITE_SESSION_TIMEOUT || '28800000'); // 8 hours in milliseconds
const ACTIVITY_CHECK_INTERVAL = 60000; // Check every minute
const SESSION_KEY = 'admin_session';

class SessionManager {
  private sessionTimer: number | null = null;
  private activityTimer: number | null = null;
  private lastActivity: number = Date.now();
  private activityHandler: (() => void) | null = null;

  startSession() {
    // Clean up any existing listeners before starting new session
    this.cleanup();
    this.lastActivity = Date.now();
    this.saveSessionData();
    this.startActivityMonitoring();
    this.startSessionTimer();
  }

  endSession() {
    this.cleanup();
    this.clearSessionData();
  }

  renewSession() {
    this.lastActivity = Date.now();
    this.saveSessionData();
  }

  private startActivityMonitoring() {
    const activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart'] as const;

    // ローカル変数へ入れてから登録する。`this.activityHandler!` は AGENTS.md 3 で禁止。
    const handler = () => {
      this.renewSession();
    };
    this.activityHandler = handler;

    activityEvents.forEach((event) => {
      window.addEventListener(event, handler);
    });

    // Check for inactivity
    this.activityTimer = window.setInterval(() => {
      const inactiveTime = Date.now() - this.lastActivity;

      if (inactiveTime >= SESSION_TIMEOUT) {
        logger.logSessionTimeout();
        this.handleSessionTimeout();
      }
    }, ACTIVITY_CHECK_INTERVAL);
  }

  private startSessionTimer() {
    this.sessionTimer = window.setTimeout(() => {
      logger.logSessionTimeout();
      this.handleSessionTimeout();
    }, SESSION_TIMEOUT);
  }

  private handleSessionTimeout() {
    this.endSession();
    window.location.href = '/login?timeout=true';
  }

  private cleanup() {
    // Remove event listeners
    const handler = this.activityHandler;
    if (handler) {
      const activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart'] as const;
      activityEvents.forEach((event) => {
        // ローカルへ退避してから解除する（コールバック内では絞り込みが効かないため
        // 以前は `this.activityHandler!` を使っていた。AGENTS.md 3）。
        window.removeEventListener(event, handler);
      });
      this.activityHandler = null;
    }

    // Clear timers
    if (this.sessionTimer) {
      clearTimeout(this.sessionTimer);
      this.sessionTimer = null;
    }
    if (this.activityTimer) {
      clearInterval(this.activityTimer);
      this.activityTimer = null;
    }
  }

  private saveSessionData() {
    const sessionData = {
      lastActivity: this.lastActivity,
      startTime: Date.now(),
    };
    localStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
  }

  private clearSessionData() {
    localStorage.removeItem(SESSION_KEY);
  }

  getSessionData() {
    const data = localStorage.getItem(SESSION_KEY);
    return data ? JSON.parse(data) : null;
  }
}

export const sessionManager = new SessionManager();
